module.exports = __webpack_public_path__ + "img/base_restauration_brasserie.ad78d6e5.svg";